/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfReport } from '../../models/data-page-of-report';

export interface ReportsGetReportType$Params {
  pageSize?: number;
  pageNumber?: number;
  reportCategoryId?: number;
  reportType?: number;
}

export function reportsGetReportType(http: HttpClient, rootUrl: string, params?: ReportsGetReportType$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfReport>> {
  const rb = new RequestBuilder(rootUrl, reportsGetReportType.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('reportCategoryId', params.reportCategoryId, {});
    rb.query('reportType', params.reportType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfReport>;
    })
  );
}

reportsGetReportType.PATH = '/api/Reports/report/reportType';
